import {SET_RECAPTCHA_RESPONSE, submitFailure, submitSuccess, submitWaiting} from "./actions";
import {select} from 'redux-saga/effects'
import {sendToServer} from "../utils/sagas";

function* saga() {
    yield* sendToServer({
        EVENT:   SET_RECAPTCHA_RESPONSE,
        request: function* (event) {
            const data = yield select((state) => state.contact.request);
            return {
                url:  '/api/contact',
                data: {...data, response: event.payload}
            };
        },
        waiting: submitWaiting,
        success: submitSuccess,
        failure: submitFailure
    });
}

export default saga;



// WEBPACK FOOTER //
// ./src/app/contact/sagas.js